import React from 'react';
import QrScanner from 'react-qr-scanner';

interface QRScannerProps {
    onScan: (data: string | null) => void;
    onError: (error: any) => void;
}

const Scanner: React.FC<QRScannerProps> = ({ onScan, onError }) => {
    return (
        <QrScanner
            delay={300}
            onError={onError}
            onScan={onScan}
            style={{ width: '100%' }}
            constraints={{ video: { facingMode: 'environment' } }}
        />
    );
};

export default Scanner;
